module.exports = __webpack_public_path__ + "lang/pl.json";


//////////////////
// WEBPACK FOOTER
// ./lang/pl.json
// module id = 81
// module chunks = d-game